// Components
import { IconChevronDown } from '@tracklib/kit'

import styles from './label.css'

export const OnlyLarge = ({ children, reversed }: { children: JSX.Element | string; reversed?: boolean }) => (
  <span className={reversed ? styles.onlyLargeReversed : styles.onlyLarge}>{children}</span>
)

const Label = ({ children }: { children: JSX.Element | string }) => (
  <div className={styles.innerLabel}>
    <em>{children}</em> <IconChevronDown />
  </div>
)

export default Label
